import React from 'react';
import { motion } from 'framer-motion';
import './CaseStudies.css';

const CaseStudies = () => {
  const cases = [
    {
      id: 1,
      title: "EdTech Revolution",
      industry: "Education Technology",
      description: "Scalable microservices architecture reduced latency by 43% and supported 2M+ monthly active users.",
      tech: ["React", "Node.js", "MongoDB"],
      impact: "+43% Performance"
    },
    {
      id: 2,
      title: "Smart F&B Platform",
      industry: "Food & Beverage",
      description: "AI-driven ordering ecosystem boosted repeat orders by 67% and integrated real-time analytics dashboard.",
      tech: ["Next.js", "Python", "PostgreSQL"],
      impact: "+67% Repeat Orders"
    },
    {
      id: 3,
      title: "Real Estate CRM",
      industry: "Property Tech",
      description: "Custom CRM & automation suite increased lead conversion by 32% for enterprise real estate clients.",
      tech: ["Laravel", "Vue.js", "AWS"],
      impact: "+32% Conversions"
    }
  ];

  return (
    <section id="work" className="case-studies">
      <div className="container">
        <h2 className="section-title">Featured <span className="gradient-text">Case Studies</span></h2>
        <p className="section-subtitle">Real impact for real businesses — from ed-tech to hospitality</p>
        
        <div className="cases-grid">
          {cases.map((caseStudy, index) => (
            <motion.div
              key={caseStudy.id}
              className="case-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="case-badge">{caseStudy.industry}</div>
              <h3>{caseStudy.title}</h3>
              <p>{caseStudy.description}</p>
              <div className="tech-stack">
                {caseStudy.tech.map(tech => (
                  <span key={tech} className="tech-tag">{tech}</span>
                ))}
              </div>
              <div className="case-impact">{caseStudy.impact}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;